module.exports = __webpack_public_path__ + "static/media/27.1494105c.jpeg";